import { Pipe, PipeTransform } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Pipe({ name: 'formatDuration' })
export class FormatDurationPipe implements PipeTransform {

  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly translate: TranslateService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  transform(value: number, unit: moment.unitOfTime.DurationConstructor): string {

    const duration = moment.duration(value, unit);

    const days = duration.asDays();
    if (days >= 1) {
      const daysAsString = days.toFixed(0);
      return `${daysAsString} ${daysAsString === '1' ? this.translate.instant('DURATION.DAY') : this.translate.instant('DURATION.DAYS')}`;
    }

    const hours = duration.asHours();
    if (hours >= 1) {
      const hoursAsString = hours.toFixed(0);
      return `${hoursAsString} ${hoursAsString === '1' ? this.translate.instant('DURATION.HOUR') : this.translate.instant('DURATION.HOURS')}`;
    }

    const minutes = duration.asMinutes();
    const minutesAsString = minutes.toFixed(0);

    return `${minutesAsString} ${minutesAsString === '1' ? this.translate.instant('DURATION.MINUTE') : this.translate.instant('DURATION.MINUTES')}`;
  }
}
